import { render, staticRenderFns } from "./AeMenuItem.vue?vue&type=template&id=3b73341b&scoped=true"
import script from "./AeMenuItem.vue?vue&type=script&lang=js"
export * from "./AeMenuItem.vue?vue&type=script&lang=js"
import style0 from "./AeMenuItem.vue?vue&type=style&index=0&id=3b73341b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b73341b",
  null
  
)

export default component.exports